import * as React from 'react';
import { connect } from 'react-redux';
import { assign as _assign } from 'lodash';
import { requestAPIActions } from 'loopback-react-request';
import { BuiltInPartsDefaultModel, BuiltInPartsModel } from 'franke-trough-dependencies';

import { match as Match, Route } from 'react-router';
import { GlobalPrivateState, NavigationConfigurationKeys, formatMessage, BuiltInPartsKeys } from 'src/api';
import { ConfigurationHeader, ConfigurationPartProps, ConfigurationPart } from 'src/app/Partials';
import { Accordion } from 'src/app/Container';
import MESSAGES from '../ConfigurationDetail.messages';
import './ConfigurationRecesses.page.scss';
import { isConfigurationEditable } from 'src/redux/utils.redux';
import CutOutDisposalModal from 'src/app/Partials/Configuration/Inputs/Recesses/CutOutDisposalModal/CutOutDisposalModal';

import {
  TapHole,
  SoapDispenserHole,
  CutOutDisposal,
  CosmeticTissueDispenser,
  TowelRail,
  ElementNext,
} from 'src/app/Partials/Configuration/Inputs';



export interface ConfigurationRecessesPageProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  validated: GlobalPrivateState['validatedConfiguration'];
}

export class ConfigurationRecessesComponent extends React.Component<ConfigurationRecessesPageProps, any> {
  componentDidMount() {
    this.dispatchDefaults();
  }
  
  shouldComponentUpdate(nextProps: any, nextState: any) {
    // At the moment every time the configuration changes it forces every child component to re-render which causes CutOutDisposal to lose it's activePositionIndex state...
    return false;
  }

  public render() {
    return (
      <div className="page-configuration-recesses">
        <div className="col-12">
          <ConfigurationHeader
            icon="recesses-built-in-parts"
            title={formatMessage(MESSAGES.recessesBuiltInPartsTitle)}
          />
        </div>
        <div className="configuration-wrap pl-5 pr-5 pt-1">
          <div className="col-12 pb-3 pl-0 pr-0">
            <Accordion>
              {this.reccesParts.map((props, index) => {
                const key = `configuration_recess_${index}`;
                return (
                  <ConfigurationPart
                    key={key}
                    {...props}
                  />
                );
              })}
            </Accordion>
            {this.configurationId && (
                <Route path={`/configuration/${this.configurationId}/recesses/:cutoutId`} exact={true} render={(props: { match?: Match<{cutoutId?: string}>}) => {
                  const cutoutId = props.match && props.match.params && props.match.params.cutoutId;
                  const backUrl = props.match && cutoutId && props.match.url.replace(`/${cutoutId}`, '');
                   
                  return cutoutId && backUrl ? (
                    <CutOutDisposalModal cutoutId={cutoutId} backUrl={backUrl} />
                  ) : null;
                }} />
              )}
          </div>
          <div className="col-12 pt-4 text-center">
            <ElementNext id={NavigationConfigurationKeys.builtInParts} />
          </div>
        </div>
      </div>
    );
  }

  private get configurationId(): string | undefined {
    return this.props.configuration.result && this.props.configuration.result.id;
  }

  private get defaults(): BuiltInPartsDefaultModel | undefined {
    const { configuration } = this.props;
    const confDefaults = configuration.result && configuration.result && configuration.result.defaults;
    return confDefaults && confDefaults.builtInParts;
  }
  
  private dispatchDefaults() {
    const { configuration } = this.props;

    if (!isConfigurationEditable()) { return; }
    
    if (configuration && configuration.result && !configuration.result.builtInParts) {
      const defaults = this.defaults;
      if (defaults) {
        const data: BuiltInPartsModel | {} = {};
        Object.keys(defaults).map(key => {
          data[key] = defaults[key].default;
        });
        this.props.dispatch(requestAPIActions.load(
          'configuration',
          {
            url: `/Configurations/${configuration.result.id}`,
            options: {
              method: 'PATCH',
              data: {builtInParts: data},
            },
          },
          true
        ));
      }
    }
  }
  
  private get reccesParts(): ConfigurationPartProps[] {
    const validated = this.props.validated.byItem.builtInParts;    
    return [{
      btnName: formatMessage(MESSAGES.tapHole),
      component: TapHole,
      error: [
        validated && validated.tapHole || false,
        validated && validated.tapHolePositions || false,
      ] || undefined,
      id: BuiltInPartsKeys.TapHole,
    }, {
      btnName: formatMessage(MESSAGES.soapDispenserHole),
      component: SoapDispenserHole,
      error: [
        validated && validated.soapDispenserHole || false,
        validated && validated.soapDispenserHolePositions || false,
      ] || undefined,
      id: BuiltInPartsKeys.SoapDispenserHole,
    }, {
      btnName: formatMessage(MESSAGES.paperTowelDispenserHole),
      component: CutOutDisposal,
      error: [
        validated && validated.withCutOutDisposals || false,
        validated && validated.withCutOutDisposalsPosition || false,
      ] || undefined,
      id: BuiltInPartsKeys.WithPaperTowelDispensers,
    }, {
      btnName: formatMessage(MESSAGES.cosmeticTissueDispenser),
      component: CosmeticTissueDispenser,
      error: [
        validated && validated.withTissueDispenser || false,
        validated && validated.withTissueDispenserPosition || false,
      ] || undefined,
      id: BuiltInPartsKeys.WithTissueDispenser,
    }, {
      btnName: formatMessage(MESSAGES.towelRail),
      component: TowelRail,
      error: [
        validated && validated.towelRail || false,
        validated && validated.towelRailPosition || false,
      ] || undefined,
      id: BuiltInPartsKeys.TowelRail,
    }];
  }
}


export const ConfigurationRecessesPage = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration, 
  validated: state.validatedConfiguration,
}))(ConfigurationRecessesComponent);

export default ConfigurationRecessesPage;

